let isLoggingOut = false;

const HandleLogout = () => {
  if (isLoggingOut) return;
  isLoggingOut = true;

  localStorage.clear();
  try {
    localStorage.setItem("logout", Date.now().toString());
  } catch (e) {
    // ignore storage write failure
  }

  if (window.location.pathname !== "/login") {
    window.location.replace("/login");
  } else {
    window.location.reload();
  }
};

export default HandleLogout;
